import { requestTimeout, handleResponse } from "../utils";
// import Cookies from 'js-cookie'
// import { Cookies } from 'react-cookie'

const apiUrl = process.env.REACT_APP_API_URL;
const appUrl = process.env.REACT_APP_URL;
const accessToken = process.env.REACT_APP_ACCESS_TOKEN;
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME;

// const cookie = new Cookies();

export const authApi = {
  _login,
  _logout,
  _register,
  _request_otp,
  _check_otp,
  _change_password,
  _auth_check,
  _forget_password,
  _check_reset,
  _reset_password,
  _set_csrf,
  _me,
  _updateUser,
  _updatePassword,
};

async function _logout() {
  // cookie.remove(auth_cookie)
  // Cookies.remove(auth_cookie, { domain: process.env.REACT_APP_DOMAIN })
  // const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)

  const requestOptions = {
    method: "GET",
    headers: {
      // 'Authorization': 'Bearer '+ token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  return requestTimeout(apiMaxTime, fetch(apiUrl + "logout", requestOptions))
    .then(handleResponse)
    .then(() => {
      localStorage.removeItem(process.env.REACT_APP_AUTH_COOKIE);
      return true;
    });
}

async function _login(form_data) {
  let auth_data = {
    ...form_data,
  };
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(auth_data),
  };
  return requestTimeout(apiMaxTime, fetch(apiUrl + "login", requestOptions))
    .then(handleResponse)
    .then((response) => {
      localStorage.setItem(process.env.REACT_APP_AUTH_COOKIE, response.token);
      return { user: response.user, token: response.token };
    });
}

async function _register(form_data) {
  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(form_data),
  };
  return requestTimeout(apiMaxTime, fetch(apiUrl + "register", requestOptions))
    .then(handleResponse)
    .then((response) => {
      // Store token if present in response
      if (response.token) {
        localStorage.setItem(process.env.REACT_APP_AUTH_COOKIE, response.token);
      }
      return response;
    });
}

async function _request_otp(form_data) {
  // let token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE)
  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      // 'Authorization': 'Bearer '+ token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(form_data),
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "otp-request", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _check_otp(form_data) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(form_data),
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "otp-confirm", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _change_password(form_data) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(form_data),
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "otp-change-password", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _forget_password(form_data) {
  let token = localStorage.getItem(accessToken);
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(form_data),
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "forget-password", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _reset_password(form_data) {
  let token = localStorage.getItem(accessToken);
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(form_data),
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "reset-password", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _check_reset(form_data) {
  let token = localStorage.getItem(accessToken);
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(form_data),
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "check-reset", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _auth_check() {
  let token = localStorage.getItem(accessToken);
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return requestTimeout(apiMaxTime, fetch(apiUrl + "auth", requestOptions))
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _set_csrf() {
  const requestOptions = {
    method: "GET",
    credentials: "include",
  };
  return await fetch(appUrl + "sanctum/csrf-cookie", requestOptions);
}

async function _me() {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  return requestTimeout(apiMaxTime, fetch(apiUrl + "me", requestOptions))
    .then(handleResponse)
    .then((response) => {
      return { user: response.user };
    });
}

async function _updateUser(payload) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "account/user/update", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _updatePassword(payload) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "account/user/password", requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}
